import {writable} from 'svelte/store';
import {I_DEAL} from "../../../../../lib/datatypes";
import {sortCompareDESC} from "../../../../../lib/utils";

export const deals = writable({
    list: [],
    lookup: {},
});
export const deals_fetching = writable(false);

const _createLookup = list => {
    let result = {};
    for(let i = 0, n = list.length; i < n; i++) {
        result[list[i][I_DEAL.ID]] = list[i];
    }
    return result;
};


const _updateStructures = deals => {
    deals.list.sort((a, b) => sortCompareDESC(a[I_DEAL.UPDATED], b[I_DEAL.UPDATED]));
    deals.lookup = _createLookup(deals.list);
};

let $deals = null;
const unsubscribe = deals.subscribe(val => $deals = val);

// Explicitly set the contents of deals by passing them in, ie from bootstrapped data
export const setDeals = deals_data => {
    deals.update(deals => {
        deals.list = deals_data;
        _updateStructures(deals);
        return deals;
    });
};

export const loadDeals = async () => {
    deals_fetching.set(true);

    const response = await fetch(`/api/deals`);
    let result = await response.json();
    deals_fetching.set(false);
    deals.update(deals => {
        deals.list = result;
        _updateStructures(deals);
        return deals;
    });
};

export const addRawDeal = async deal_arr => {
    deals_fetching.set(true);

    const url = `/api/deal/add`;
    const response = await fetch(url, {
        method: 'POST',
        body: JSON.stringify(deal_arr)
    });
    let result = await response.json();
    deals_fetching.set(false);
    deals.update(deals => {
        deals.list.push(result);
        _updateStructures(deals);
        return deals;
    });
    return result;
};

export const updateRawDeal = async deal => {
    deals_fetching.set(true);

    const url = `/api/deal/${deal[I_DEAL.ID]}/update`;
    const response = await fetch(url, {
        method: 'POST',
        body: JSON.stringify(deal)
    });
    let result = await response.json();
    // console.log(response, result);
    // ..update local copy of deals with the updated data - could just download the data again (server would have updated data), but..
    const i = $deals.list.findIndex(el => el[I_DEAL.ID] === deal[I_DEAL.ID]);
    deals_fetching.set(false);
    deals.update(deals => {
        deals.list[i] = result;  // @ASSUMPTION that the result will always contain a successful object, ie doesn't handle errors
        _updateStructures(deals);
        return deals;
    });
    return result;
};